import React, { useState, useEffect } from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

// Flash Message Component
const FlashMessage = ({ notice, alert }) => {
  if (!notice && !alert) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '90px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1050,
        maxWidth: '600px',
        width: '90%',
      }}
    >
      {notice && (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {notice}
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      )}
      {alert && (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {alert}
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      )}
    </div>
  );
};

// Shared layout wrapper for public pages (pricing, features, programs, landing)
const PublicPageLayout = ({ children, loginPath = '/login', flashNotice, flashAlert, t }) => {
  const currentYear = new Date().getFullYear();

  // Fetch config from API
  const [socialLinks, setSocialLinks] = useState({});
  const [livechatEnabled, setLivechatEnabled] = useState(false);

  useEffect(() => {
    fetch('/api/frontend_config')
      .then((res) => res.json())
      .then((data) => {
        if (data.social_links) {
          setSocialLinks(data.social_links);
        }
        if (data.livechat_enabled !== undefined) {
          setLivechatEnabled(data.livechat_enabled);
        }
      })
      .catch(() => {
        // Silently fail - social links just won't show
      });
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <PublicHeader loginPath={loginPath} t={t} />
      <FlashMessage notice={flashNotice} alert={flashAlert} />
      <main className="flex-fill" style={{ paddingTop: '77px' }}>
        {children}
      </main>
      <PublicFooter
        currentYear={currentYear}
        t={t}
        socialLinks={socialLinks}
        livechatEnabled={livechatEnabled}
      />
    </div>
  );
};

export default PublicPageLayout;
